"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
var react_1 = __importDefault(require("react"));
var LoadingIndicator = function (_a) {
    var size = _a.size, className = _a.className;
    return (react_1.default.createElement("div", { className: "loading-wrapper items-center ".concat(className ? className : "") },
        react_1.default.createElement("svg", { className: "loading loading-".concat(size ? size : "medium"), viewBox: "0 0 50 50" },
            react_1.default.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }))));
};
exports.LoadingIndicator = LoadingIndicator;
